const prefix = 'edit-addon-modal';

export const i18n = {
    title: {
        id: `${prefix}.title`,
        defaultMessage: 'Update Subscription',
    },
    productCode: {
        id: `${prefix}.productCode`,
        defaultMessage: 'Product Code',
    },
    serialNumber: {
        id: `${prefix}.serialNumber`,
        defaultMessage: 'Serial Number',
    },
    cancel: {
        id: `${prefix}.cancel`,
        defaultMessage: 'Cancel',
    },
    save: {
        id: `${prefix}.save`,
        defaultMessage: 'Save',
    },
    saveSuccess: {
        id: `${prefix}.saveSuccess`,
        defaultMessage: 'Subscription updated',
    },
    saveError: {
        id: `${prefix}.saveError`,
        defaultMessage: 'Failed to update subscription',
    },
    deleteButton: {
        id: `${prefix}.deleteButton`,
        defaultMessage: 'Delete Subscription',
    },
    deleteConfirmTitle: {
        id: `${prefix}.deleteConfirmTitle`,
        defaultMessage: 'Delete subscription?',
    },
    deleteConfirmMessage: {
        id: `${prefix}.deleteConfirmMessage`,
        defaultMessage:
            'This will permanently remove the subscription. This action cannot be undone.',
    },
    deleteConfirmLabel: {
        id: `${prefix}.deleteConfirmLabel`,
        defaultMessage: 'Delete',
    },
    deleteCancelLabel: {
        id: `${prefix}.deleteCancelLabel`,
        defaultMessage: 'Cancel',
    },
    deleteSuccess: {
        id: `${prefix}.deleteSuccess`,
        defaultMessage: 'Subscription deleted',
    },
    deleteError: {
        id: `${prefix}.deleteError`,
        defaultMessage: 'Failed to delete subscription',
    },
} as const;
